"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphQLClientProxy = void 0;

var inversify_1 = require("inversify");

var apollo_client_1 = require("apollo-client");

var apollo_link_context_1 = require("apollo-link-context");

var apollo_link_http_1 = require("apollo-link-http");

var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");

var http_1 = require("@xbox/http");

var XSocialSymbols_1 = require("../typings/XSocialSymbols");

var fragmentTypes_1 = require("./fragmentTypes");

var CorrelationVector_1 = require("../utils/CorrelationVector");

var fetch = require("cross-fetch");

var GraphQLClientProxy =
/** @class */
function () {
  function GraphQLClientProxy(appConfig, authProvider) {
    this.appConfig = appConfig;
    this.authProvider = authProvider;
    this.client = undefined;
  }

  GraphQLClientProxy.prototype.initializeClient = function () {
    return __awaiter(this, void 0, void 0, function () {
      var httpLink, authLink, fragmentMatcher;

      var _this = this;

      return __generator(this, function (_a) {
        // check is the client was already initialized.
        if (this.client) {
          return [2
          /*return*/
          ];
        }

        try {
          authLink = apollo_link_context_1.setContext(function (_, _a) {
            var headers = _a.headers;
            return __awaiter(_this, void 0, void 0, function () {
              var authHeaders, authTokenHeader, currentUserHeader, authToken, authTokenHeader, currentUserHeader, cv, cvHeader;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    if (!this.appConfig.isServerSideRendered) return [3
                    /*break*/
                    , 1];
                    authTokenHeader = {
                      Authorization: "XBL3.0 x=15320818572447442650;eyJlbmMiOiJBMTI4Q0JDK0hTMjU2IiwiYWxnIjoiUlNBLU9BRVAiLCJjdHkiOiJKV1QiLCJ6aXAiOiJERUYiLCJ4NXQiOiIxZlVBejExYmtpWklFaE5KSVZnSDFTdTVzX2cifQ.MgQHS87cQgH7KT8X2H9GuCYdYA6qKaCftI89IC6olCfBXF7XRczexREjHMujXvAw0y4xz31TOWSynozjE2-beRTPMw8zkJ4992zM1wXWC9kAxmwUDTxRchVkD4we3gEebeLQmiTs420YKR887BiafXTNU0qA_JNhv4aIxVRBu1s.Urcb3lesEd6dVaMPbF0CXA.Sv0PRr8N9nxpL7nZ8MWQIwq233HdHZrf-16n3rxBJNqTC0JUP35zclpOLfhftGFlCYEIu4UkcZZbAJJ6zk26FfTvJtCaGqv8dLPnIKScQTkmSbCN2ABoe1phCl65KLlFQzpKKnMz9NBGu4ArRg4zazEXuMONL6i31bfikgJHc-CxQWVKcJnp1xotp11i_2RpzhPGknKd0ZGSvELBvGa429Imswi2bGNrq__TmcL1u2S306VfXnbhIOcZyz4OYrRK_ftbI-Vh6Au8d6CaJDRIpVy3sUwENphb-3wMoVQnoTQSA-pBN-sROqAT9dc1Gn9Mog4-hWrS_jTdwWiLkEJoYCTu7BDzjOj32Ggof64_9ygHW1k70WVCzvK_AcRQ5NAw2dpBGAWUQlTJREkRs5OevrT8-J8-ZS2fiFllRQ22cLTdlH--V_YjxJpl-JiUuAevwS_RQNdll-GCj7eA1Fk31deZ7WSuDVqvgdwdLOSesI2_qE20sErkzsa6SKV5SSP7vI_wr9VLyTYfLj1DanVvwTGkHEyqaLmqtclAKCeUx0fBhNlSVfE2fTeDM6zmQWwW93pkNO04wAIU2Thx4ApfTXH15rqNIPxz3gi098IQMnrpvkoWcV7npdJgMpcoP4lVweq_oGGNqsNei3i8h7frNz5MeJTa59ysZqLGU-RPymO7uvJ4ZFd0Ngx9VSfDKn54_xfCb8mOerKgFt3fFxN7bMF1KAksD_2TJ2ah8pKSsE5m1PcRNZzKyFk4hcPKcGqPB73K4uSFcu1fCk0FHBO0VpTfjJvbVrJ916OYGYrtLhYQdrZXUlZzeYpeyU6lvkTBWOwpT58Bhzu1MJnRRPFTwROnUrt9EpaieH7YqUYPJCYttIwJLUh3_ZOiEQxudZfUjkGmALLcfe7nMceIsE8sP2f3N5DvY6NkR7CNdHVJih9_BVyl3ttW2dfZh-rv4xY2DHr0MhOJNjaCTxRW1YgfLVtbeCXKpyAGcNQn-h0xt_A696U6n5y-30mJAv-uJ6dnZNofO5UcLoGJTpfNbXk82IhSjy6Z77BNIsKCeTNlEd7q7ZARB37NBTuF3QqSIZBEdph4rPLeGdvdiCIH01nthB3Xx7f6zmVe7DvBLkoAtxVEdP5rrScA8UyRfpzEBJqwsLho3NXVBpxdJulro01HXF4VPW-wxW1QB2Gr1z5E-aL7X_5jXB3OvGx8JBH00vSBsoPlKkPkyM96wZKlzIExeKMV9hNxyloIg8hcG-PSFXGka_vLx7fZm-affdpzKgXaSa1uu5ru0JNizPzsXeqgQVy4DJbDsWVRy55DH696C4x4_JVxsUvwqAdQOYqIUx71yeIjwEp_lNbFV1m3eY3W1rhlRvXbagAPocqWREpMBQzov-ZJeeBgW4g3H-IP5w4abhjmOTeqTGXwaff83YeOv9VAROz-8FC14vnei3_H0XZhs2qb6IS-WTdgJQvQuVTBAPcpzxQlC7LZxi6ZewzTkvbZnnFu4Dyy_h9Ejd01khz0thQpeAPmupb_hqxvqQY6xzO0fXmv3-aJD_TeUGzJDmz_AQgsWGj8bWXCrsuI88pVEzRzHchnWlLLJyR0swq2YGNUsrfWM17YVyeHs9XO2dODJyomicuNud3UshO_G9nZRRbzh70oHmYdwFH5qsZFkB6B1K_emwq2Sba-msggcvTRoGBOlLFyKfNvSaf9ki7ySM3QcaJ31WYeBFWNkekbi7r6wyzvHor3ytpXQ-o9_qk5VyqL5vpGFuxSksUP48mqjBt9nHXppDSSdFB_2qpCJ5JSczmXbESKUFjSTsnGV1ORzBTNbCcbEDVu6ZyCci08Znj0DjbIyuVAvmo4VqqwhPg4g7FpVqJXDcYiBq1Cf1f3J6SasbTx-4k2Qe9x8ZmzXzZQi_6WG7s7PdbXQx6YhiFDoPOE3rbRSq8M8hdMmMq5YuEy7ZQH12aDR3Zl-mN0tzEEOhZBebbrhAJuK4SucY0QJlDXXrQbf9ipoTIyaw.k-Yh4cPDnBjoBPdxquth150-0qWzTiR7YbC6ojm2sJQ"
                    };
                    currentUserHeader = {
                      "x-current-user": "2533274805319472"
                    };
                    authHeaders = __assign(__assign({}, authTokenHeader), currentUserHeader);
                    return [3
                    /*break*/
                    , 3];

                  case 1:
                    if (!this.authProvider.currentUser) {
                      throw new Error("No user signed in.");
                    }

                    return [4
                    /*yield*/
                    , this.authProvider.getTokenAndSignature({
                      url: "https://xboxlive.com",
                      method: http_1.Http.HttpRequestMethod.Get
                    })];

                  case 2:
                    authToken = _b.sent();

                    if (authToken.token) {
                      authTokenHeader = {
                        Authorization: authToken.token
                      };
                      currentUserHeader = {
                        "x-current-user": this.authProvider.currentUser.xuid
                      };
                      authHeaders = __assign(__assign({}, authTokenHeader), currentUserHeader);
                    } else {
                      throw new Error("Authentication not initialized.");
                    }

                    _b.label = 3;

                  case 3:
                    cv = CorrelationVector_1.generateCV();
                    cvHeader = {
                      "MS-CV": cv
                    }; // return the headers to the context so httpLink can read them

                    return [2
                    /*return*/
                    , {
                      headers: __assign(__assign(__assign({}, headers), authHeaders), cvHeader)
                    }];
                }
              });
            });
          });

          if (this.appConfig.isServerSideRendered === true) {
            httpLink = apollo_link_http_1.createHttpLink({
              uri: this.appConfig.graphQLUri,
              fetch: fetch.fetch
            });
          } else {
            httpLink = apollo_link_http_1.createHttpLink({
              uri: this.appConfig.graphQLUri
            });
          }

          fragmentMatcher = new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
            introspectionQueryResultData: fragmentTypes_1.default
          });
          this.client = new apollo_client_1.ApolloClient({
            link: authLink.concat(httpLink),
            cache: new apollo_cache_inmemory_1.InMemoryCache({
              fragmentMatcher: fragmentMatcher
            }),
            ssrMode: this.appConfig.isServerSideRendered === true
          });
          return [2
          /*return*/
          ];
        } catch (e) {
          console.warn(e);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  GraphQLClientProxy.prototype.query = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // check if client is ready
            return [4
            /*yield*/
            , this.initializeClient()];

          case 1:
            // check if client is ready
            _a.sent();

            if (this.client) {
              // execute query
              return [2
              /*return*/
              , this.client.query(options)];
            } else {
              throw new Error("GrpahQL Client is not ready.");
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GraphQLClientProxy.prototype.mutate = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // check if client is ready
            return [4
            /*yield*/
            , this.initializeClient()];

          case 1:
            // check if client is ready
            _a.sent();

            if (this.client) {
              // execute mutate
              return [2
              /*return*/
              , this.client.mutate(options)];
            } else {
              throw new Error("GrpahQL Client is not ready.");
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GraphQLClientProxy = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(XSocialSymbols_1.XSocialSymbols.IAppConfig)), __param(1, inversify_1.inject(XSocialSymbols_1.XSocialSymbols.IXalAuthProvider)), __metadata("design:paramtypes", [Object, Object])], GraphQLClientProxy);
  return GraphQLClientProxy;
}();

exports.GraphQLClientProxy = GraphQLClientProxy;